import { createFileRoute } from '@tanstack/react-router'

import { redirectNlUsersToPaymentMethods } from '#/shared/routing/redirect-nl-users-to-payment-methods.ts'

// The NL guard sits on the layout so both the list and the payment screen inherit it. Per-screen
// permissions live on the leaves, which need different ones (read vs pay).
export const Route = createFileRoute('/(customer)/_shell/unpaid-invoices')({
  beforeLoad: ({ context }) => redirectNlUsersToPaymentMethods(context),
})
